// src/pages/Home/homeData.js

import { FaGlobe, FaFlask, FaBox, FaChartPie } from "react-icons/fa";

/**
 * 1) Your slider items (videos, names, descs, categories — from your CDN)
 */
export const categoryImages = [
  {
    id: 1,
    image: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mutfak.mp4",
    webm: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mutfak.webm",
    mobileImage: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mobile/mutfak.mp4",
    mobileWebm: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mobile/mutfak.webm",
    name: "Mutfak Hİjyenİ",
    category: "mutfak",
    description: "KRL Kimya ürünleri ile mutfaklarınızda %100 hijyen.",
    poster: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mutfak.jpg"
  },
  {
    id: 2,
    image: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/bina_bakimi.mp4",
    webm: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/bina_bakimi.webm",
    mobileImage: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mobile/bina_bakimi.mp4",
    mobileWebm: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mobile/bina_bakimi.webm",
    name: "Bİna Bakımı",
    category: "bina-bakimi",
    description: "Konsantre ve çevreye duyarlı ürünlerle temiz çalışma ortamı.",
    poster: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/bina_bakimi.jpg"
  },
  {
    id: 3,
    image: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/kisisel.mp4",
    webm: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/kisisel.webm",
    mobileImage: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mobile/kisisel.mp4",
    mobileWebm: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mobile/kisisel.webm",
    name: "Kİşİsel Hİjyen",
    category: "kisisel-hijyen",
    description: "Kendinize değer katın.",
    poster: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/kisisel.jpg"
  },
  {
    id: 4,
    image: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/camasir.mp4",
    webm: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/camasir.webm",
    mobileImage: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mobile/camasir.mp4",
    mobileWebm: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mobile/camasir.webm",
    name: "Çamaşır Hİjyenİ",
    category: "camasir",
    description: "Dozajlı kullanımı ile bütçenizi, çevreyi ve tekstilinizi koruyun.",
    poster: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/camasir.jpg"
  },
  {
    id: 5,
    image: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/gida_hijyen.mp4",
    webm: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/gida_hijyen.webm",
    mobileImage: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mobile/gida_hijyen.mp4",
    mobileWebm: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mobile/gida_hijyen.webm",
    name: "Gıda Hİjyenİ",
    category: "gida-hijyeni",
    description: "Ürünlerimiz ile gıda işletmeleriniz güvende.",
    poster: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/gida_hijyen.jpg"
  },
  {
    id: 6,
    image: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/pool.mp4",
    webm: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/pool.webm",
    mobileImage: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mobile/pool.mp4",
    mobileWebm: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mobile/pool.webm",
    name: "Havuz Kİmyasalları",
    category: "havuz-kimyasallari",
    description: "Otel, villa, site vb. yerlerde havuz hijyeni sağlar.",
    poster: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/pool.jpg"
  },
  {
    id: 7,
    image: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/ozel_urunler.mp4",
    webm: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/ozel_urunler.webm",
    mobileImage: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mobile/ozel_urunler.mp4",
    mobileWebm: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mobile/ozel_urunler.webm",
    name: "Özel ÜrÜnler",
    category: "ozel-urunler",
    description: "Özel ihtiyaçlarınızda çok yönlü çözümler sağlarız.",
    poster: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/ozel_urunler.jpg"
  },
  {
    id: 8,
    image: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/endustriyel.mp4",
    webm: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/endustriyel.webm",
    mobileImage: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mobile/endustriyel.mp4",
    mobileWebm: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mobile/endustriyel.webm",
    name: "EndÜstrİyel Kİmyasallar",
    category: "endustriyel-kimya",
    description: "Kimyasal çözümlerimizle yanınızdayız.",
    poster: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/endustriyel.jpg"
  },
];


/**
 * 2) Your brands data (local images + feature lists)
 */
export const brands = [
  {
    id: 1,
    features: [
      "Sektör ihtiyaçlarına odaklı",
      "Konsantre ve ekonomik",
      "Çevreye duyarlı",
      "Pratik ve kolay kullanım",
    ],
    image: "/images/equinox_logo.png",
  },
  {
    id: 2,
    features: [
      "Gıda üretim tesislerinde hijyen",
      "Seyreltme sistemlerine uygun",
      "Yüksek konsantrasyon",
    ],
    image: "/images/endaxi_logo.png",
  },
  {
    id: 3,
    features: [
      "Sıvı ve toz endüstriyel çamaşır yıkama ürünleri",
      "Düşük su sıcaklıklarında etkin çözümler",
      "Yüksek konsantrasyon",
    ],
    image: "/images/lora_logo.png",
  },
  {
    id: 4,
    features: [
      "Sanayi üretim tesislerinde endüstriyel çözümler",
      "Bakım ve koruma kimyasalları",
      "Pratik ve kolay kullanım, hızlı çözümler",
    ],
    image: "/images/chemiccount_logo.png",
  },
];


/**
 * 3) Your certificates (local logo + CDN-hosted PDF)
 */
export const certificates = [
  {
    logo: "/images/certificate-logo1.png",
    pdf: "https://fra1.digitaloceanspaces.com/krl-kimya/certificates/certificate1.pdf",
  },
  {
    logo: "/images/certificate-logo2.png",
    pdf: "https://fra1.digitaloceanspaces.com/krl-kimya/certificates/certificate2.pdf",
  },
  {
    logo: "/images/certificate-logo3.png",
    pdf: "https://fra1.digitaloceanspaces.com/krl-kimya/certificates/certificate3.pdf",
  },
  {
    logo: "/images/certificate-logo5.png",
    pdf: "https://fra1.digitaloceanspaces.com/krl-kimya/certificates/certificate4.pdf",
  },
  // …etc
];

/**
 * 4) Your stats counters
 */
export const statsData = [
  {
    id: 1,
    icon: <FaGlobe />,
    targetNumber: 500,
    label: "YEREL VE ULUSLARARASI MÜŞTERİ",
    backgroundColor: "#3498db",
    suffix: "+",
    start: 0,
  },
  {
    id: 2,
    icon: <FaFlask />,
    targetNumber: 60000,
    label: "LİTRE ÜRETİM KAPASİTESİ",
    backgroundColor: "#2471a3",
    suffix: "+",
    start: 10000, // Start from 20,000 for faster counting
  },
  {
    id: 3,
    icon: <FaBox />,
    targetNumber: 500,
    label: "ÜRÜN KALEMİ",
    backgroundColor: "#2471a3",
    suffix: "+",
    start: 0,
  },
  {
    id: 4,
    icon: <FaChartPie />,
    targetNumber: 40,
    label: "İHRACAT ORANI",
    backgroundColor: "#1f618d",
    suffix: "%",
    start: 0,
  },
];

/**
 * 5) Your references (46 logos on CDN + optional names)
 */
export const references = Array.from({ length: 46 }, (_, idx) => ({
  id: idx + 1,
  logo: `https://krl-kimya.fra1.digitaloceanspaces.com/references/reference${
    idx + 1
  }.png`,
  name: `Company Name ${idx + 1}`, // replace if you have real names
}));
